import { createRoot } from "react-dom/client";
import App from "./App";
import { I18nProvider } from "@/lib/i18n/i18n";
import { initSentry } from "@/lib/sentry";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import "./index.css";

// Init Sentry au boot (no-op si VITE_SENTRY_DSN absent).
initSentry();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <I18nProvider>
      <App />
    </I18nProvider>
  </ErrorBoundary>
);
